export type Option = {
  value: string | string[];
  text: string;
};

export type QuestionSet = {
  question: string;
  key: string;
  options: Option[];
};

export type QuestionConfig = {
  gender: QuestionSet;
  income_range: QuestionSet;
  age_range: QuestionSet;
};

export type PermutiveData = {
  gender?: string;
  hhni?: string; // household net income
  age?: string[];
};

export const QuestionConfigData: QuestionConfig = {
  gender: {
    question: "Mit welchem Geschlecht identifizierst du dich?",
    key: "gender",
    options: [
      {
        value: "gender_female",
        text: "weiblich",
      },
      {
        value: "gender_male",
        text: "männlich",
      },
    ],
  },
  income_range: {
    question: "Wie hoch ist das monatliche Nettoeinkommen des Haushalts?",
    key: "hhni",
    options: [
      {
        value: "0-1000",
        text: "0 – unter 1.000 €",
      },
      {
        value: "1000-2000",
        text: "1.000 € – unter 2.000 €",
      },
      {
        value: "2000-3000",
        text: "2.000 € – unter 3.000 €",
      },
      {
        value: "3000-4000",
        text: "3.000 € – unter 4.000 €",
      },
      {
        value: "4000-5000",
        text: "4.000 € – unter 5.000 €",
      },
      {
        value: "5000-6000",
        text: "5.000 € – unter 6.000 €",
      },
      {
        value: "6000+",
        text: "6.000 € und mehr",
      },
      {
        value: "0",
        text: "Keine Angabe",
      },
    ],
  },
  age_range: {
    question: "Wie alt bist du?",
    key: "age",
    options: [
      {
        value: ["18-24", "18-29"],
        text: "18 – 24 Jahre",
      },
      {
        value: ["18-29"],
        text: "25 – 29 Jahre",
      },
      {
        value: ["25-34", "30-39"],
        text: "30 – 34 Jahre",
      },
      {
        value: ["30-39", "35-44"],
        text: "30 – 39 Jahre",
      },
      {
        value: ["35-44", "40-49"],
        text: "40 – 44 Jahre",
      },
      {
        value: ["40-49", "45-54"],
        text: "45 – 49 Jahre",
      },
      {
        value: ["45-54", "50-59"],
        text: "50 – 54 Jahre",
      },
      {
        value: ["50-59", "55-64"],
        text: "55 – 59 Jahre",
      },
      {
        value: ["55-64", "60"],
        text: "60 – 64 Jahre",
      },
      {
        value: "65+",
        text: "65+ Jahre",
      },
    ],
  },
};
